import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
}
export function CTAButton({
  variant = 'primary',
  children,
  onClick,
  className = '',
  ariaLabel
}: CTAButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 w-full sm:w-auto text-center';
  const variantStyles = {
    primary: 'bg-brand-red text-white hover:bg-red-700 shadow-lg hover:shadow-xl',
    secondary: 'bg-transparent border-2 border-gray-300 text-gray-900 hover:border-gray-400 hover:bg-gray-50'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variantStyles[variant]} ${className}`} onClick={onClick} aria-label={ariaLabel} data-id="element-65">
      {children}
    </motion.button>;
}